import { getWeChatSignature } from 'services/WeChatAPIHelper';
import { setWeChatConfig, inMiniProgram } from 'utils/WeChatUtil'
import { WE_CHAT_OFFICIAL_ACCOUNT_APP_ID } from "utils/Config";

export default {
  namespace: 'weChat',
  state: {},

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clearState() {
      return {};
    },
  },

  effects: {
    setUpWeChatConfig: [
      function* ({ payload }, { call, put, select, all }) {
        const onFailed = payload.onFailed || (() => { })
        const isInMiniProgram = inMiniProgram()
        if (!isInMiniProgram) {
          onFailed()
          return
        }
        const url = encodeURIComponent(window.location.href.split('#')[0]);
        console.log("setUpWeChatConfig url:", url)
        const response = yield call(getWeChatSignature, {
          app_id: WE_CHAT_OFFICIAL_ACCOUNT_APP_ID,
          url: url,
        })
        if (!response) {
          onFailed()
          return
        }
        if (response.status > 300) {
          onFailed()
          return 
        }
        const data = response.data
        const signature = data.signature
        const timestamp = data.timestamp
        const nonceStr = data.nonce_str
        setWeChatConfig(timestamp, nonceStr, signature)

      },
      { type: 'takeLatest' },
    ],
  },
};
